// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doc-panel {
  /* \`--bg-surface\`: el panel de documentación FLOTA (cajón fijo a la derecha o
     columna pegajosa). Con la tarjeta de cristal de los skins se leía lo de
     detrás. */
  background: var(--bg-surface);
  border: 1px solid var(--border);
  box-shadow: 0 20px 60px rgba(0,0,0,.5);
  z-index: 1200;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  position: relative;
}

.doc-panel-drawer {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  border-left: 1px solid var(--border);
  box-shadow: -10px 0 30px rgba(0,0,0,.4);
}

.doc-panel-inline {
  position: sticky;
  top: 1rem;
  height: calc(100vh - 2rem);
  width: 100%;
  align-self: flex-start;
}

.doc-panel-full {
  position: static;
  width: 100%;
  height: auto;
  box-shadow: none;
}

.doc-panel-full .doc-panel-body {
  max-height: none;
  overflow: visible;
}

.doc-panel-header {
  padding: 1rem 1rem 0.5rem 1.25rem;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.doc-panel-eyebrow {
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 0.78rem;
  color: var(--text-muted);
}

.doc-panel-title {
  margin: 0.1rem 0 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary);
}

.doc-panel-body {
  padding: 1rem 1rem 1.25rem 1.25rem;
  overflow-y: auto;
  flex: 1 1;
}

.doc-panel-inline .doc-panel-body {
  overflow: visible;
}

.doc-panel-full .doc-panel-body {
  overflow: visible;
}

.doc-grid {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 12px;
  align-items: stretch;
}

.doc-panel-full .doc-grid {
  grid-template-columns: 340px 1fr;
  height: calc(100vh - 170px);
}

.doc-list-panel,
.doc-detail-panel {
  min-height: 480px;
}

.doc-panel-inline .doc-list-panel {
  min-height: auto;
}

.doc-panel-full .doc-detail-panel {
  min-height: auto;
  height: 100%;
}

.doc-list-filters {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.doc-list-scroll {
  max-height: 520px;
  overflow-y: auto;
}

.doc-panel-full .doc-list-scroll {
  max-height: none;
  height: 100%;
}

.doc-panel-inline .doc-panel-body {
  max-height: calc(100vh - 120px);
}

.doc-create .form-label {
  font-weight: 600;
}

.list-group-item.active {
  background: rgba(var(--accent-rgb),.15);
  color: var(--text-primary);
  border-color: rgba(var(--accent-rgb),.3);
}

.doc-detail .card-header {
  background: var(--bg-toolbar);
  color: var(--text-primary);
  border-bottom: 1px solid var(--border);
}

.doc-internal textarea {
  border-radius: 10px;
}

.doc-quill .ql-container {
  min-height: 180px;
  border-radius: 10px;
}

.doc-quill-tall .ql-container {
  min-height: 320px;
}

.doc-quill .ql-container {
  min-height: 180px;
  border-radius: 10px;
}

.doc-quill .ql-toolbar {
  border-radius: 10px 10px 0 0;
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--bg-toolbar);
  border-color: var(--slate-300);
}

.doc-version-content {
  background: var(--bg-toolbar);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 0.75rem;
  margin-top: 0.35rem;
  color: var(--text-primary);
}

.doc-version-latest {
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 12px;
  background: var(--bg-toolbar);
}

.doc-resize-handle {
  position: absolute;
  left: -6px;
  top: 0;
  width: 10px;
  height: 100%;
  cursor: ew-resize;
  z-index: 10;
}

.doc-quick-actions .btn {
  border-radius: 999px;
}

.doc-workspace {
  max-width: 1400px;
}

.doc-workspace-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.doc-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
}

.doc-modal-backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.35);
}

.doc-modal-content {
  position: relative;
  z-index: 1;
  max-width: 900px;
  margin: 4vh auto;
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: 0 30px 80px rgba(0,0,0,.6);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.doc-modal .doc-create {
  margin-bottom: 0;
  box-shadow: none;
}

.doc-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border);
  background: linear-gradient(120deg, #1e1b4b 0%, #312e81 60%, #4338ca 100%);
}

.doc-modal-body {
  padding: 1rem 1.25rem 1.5rem;
}

.doc-quill-modal .ql-container {
  min-height: 420px;
}

.doc-empty {
  border: 1px dashed var(--slate-300);
  background: var(--bg-toolbar);
}

@media (max-width: 768px) {
  .doc-panel-drawer,
  .doc-panel-inline {
    width: 100%;
    height: auto;
    position: static;
    max-height: none;
  }

  .doc-panel-inline .doc-panel-body {
    max-height: none;
  }

  .doc-resize-handle {
    display: none;
  }

  .doc-grid {
    grid-template-columns: 1fr;
  }

  .doc-list-scroll {
    max-height: none;
  }
}

@media (max-width: 768px) {
  .doc-panel {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DocumentPanel.css"],"names":[],"mappings":"AAAA;EACE;;cAEY;EACZ,6BAA6B;EAC7B,+BAA+B;EAC/B,sCAAsC;EACtC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;EAC1B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,sCAAsC;EACtC,0EAA0E;AAC5E;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE;;IAEE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF","sourcesContent":[".doc-panel {\r\n  /* `--bg-surface`: el panel de documentación FLOTA (cajón fijo a la derecha o\r\n     columna pegajosa). Con la tarjeta de cristal de los skins se leía lo de\r\n     detrás. */\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  box-shadow: 0 20px 60px rgba(0,0,0,.5);\r\n  z-index: 1200;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: 12px;\r\n  position: relative;\r\n}\r\n\r\n.doc-panel-drawer {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  height: 100vh;\r\n  border-left: 1px solid var(--border);\r\n  box-shadow: -10px 0 30px rgba(0,0,0,.4);\r\n}\r\n\r\n.doc-panel-inline {\r\n  position: sticky;\r\n  top: 1rem;\r\n  height: calc(100vh - 2rem);\r\n  width: 100%;\r\n  align-self: flex-start;\r\n}\r\n\r\n.doc-panel-full {\r\n  position: static;\r\n  width: 100%;\r\n  height: auto;\r\n  box-shadow: none;\r\n}\r\n\r\n.doc-panel-full .doc-panel-body {\r\n  max-height: none;\r\n  overflow: visible;\r\n}\r\n\r\n.doc-panel-header {\r\n  padding: 1rem 1rem 0.5rem 1.25rem;\r\n  border-bottom: 1px solid var(--border);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.doc-panel-eyebrow {\r\n  margin: 0;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.08em;\r\n  font-size: 0.78rem;\r\n  color: var(--text-muted);\r\n}\r\n\r\n.doc-panel-title {\r\n  margin: 0.1rem 0 0;\r\n  font-size: 1.1rem;\r\n  font-weight: 700;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.doc-panel-body {\r\n  padding: 1rem 1rem 1.25rem 1.25rem;\r\n  overflow-y: auto;\r\n  flex: 1;\r\n}\r\n\r\n.doc-panel-inline .doc-panel-body {\r\n  overflow: visible;\r\n}\r\n\r\n.doc-panel-full .doc-panel-body {\r\n  overflow: visible;\r\n}\r\n\r\n.doc-grid {\r\n  display: grid;\r\n  grid-template-columns: 340px 1fr;\r\n  gap: 12px;\r\n  align-items: stretch;\r\n}\r\n\r\n.doc-panel-full .doc-grid {\r\n  grid-template-columns: 340px 1fr;\r\n  height: calc(100vh - 170px);\r\n}\r\n\r\n.doc-list-panel,\r\n.doc-detail-panel {\r\n  min-height: 480px;\r\n}\r\n\r\n.doc-panel-inline .doc-list-panel {\r\n  min-height: auto;\r\n}\r\n\r\n.doc-panel-full .doc-detail-panel {\r\n  min-height: auto;\r\n  height: 100%;\r\n}\r\n\r\n.doc-list-filters {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.doc-list-scroll {\r\n  max-height: 520px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.doc-panel-full .doc-list-scroll {\r\n  max-height: none;\r\n  height: 100%;\r\n}\r\n\r\n.doc-panel-inline .doc-panel-body {\r\n  max-height: calc(100vh - 120px);\r\n}\r\n\r\n.doc-create .form-label {\r\n  font-weight: 600;\r\n}\r\n\r\n.list-group-item.active {\r\n  background: rgba(var(--accent-rgb),.15);\r\n  color: var(--text-primary);\r\n  border-color: rgba(var(--accent-rgb),.3);\r\n}\r\n\r\n.doc-detail .card-header {\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-primary);\r\n  border-bottom: 1px solid var(--border);\r\n}\r\n\r\n.doc-internal textarea {\r\n  border-radius: 10px;\r\n}\r\n\r\n.doc-quill .ql-container {\r\n  min-height: 180px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.doc-quill-tall .ql-container {\r\n  min-height: 320px;\r\n}\r\n\r\n.doc-quill .ql-container {\r\n  min-height: 180px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.doc-quill .ql-toolbar {\r\n  border-radius: 10px 10px 0 0;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 2;\r\n  background: var(--bg-toolbar);\r\n  border-color: var(--slate-300);\r\n}\r\n\r\n.doc-version-content {\r\n  background: var(--bg-toolbar);\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 0.75rem;\r\n  margin-top: 0.35rem;\r\n  color: var(--text-primary);\r\n}\r\n\r\n.doc-version-latest {\r\n  border: 1px solid var(--border);\r\n  border-radius: 10px;\r\n  padding: 12px;\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n.doc-resize-handle {\r\n  position: absolute;\r\n  left: -6px;\r\n  top: 0;\r\n  width: 10px;\r\n  height: 100%;\r\n  cursor: ew-resize;\r\n  z-index: 10;\r\n}\r\n\r\n.doc-quick-actions .btn {\r\n  border-radius: 999px;\r\n}\r\n\r\n.doc-workspace {\r\n  max-width: 1400px;\r\n}\r\n\r\n.doc-workspace-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 12px;\r\n}\r\n\r\n.doc-modal {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 2000;\r\n}\r\n\r\n.doc-modal-backdrop {\r\n  position: absolute;\r\n  inset: 0;\r\n  background: rgba(15, 23, 42, 0.35);\r\n}\r\n\r\n.doc-modal-content {\r\n  position: relative;\r\n  z-index: 1;\r\n  max-width: 900px;\r\n  margin: 4vh auto;\r\n  background: var(--bg-surface);\r\n  border: 1px solid var(--border);\r\n  border-radius: 14px;\r\n  box-shadow: 0 30px 80px rgba(0,0,0,.6);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n}\r\n\r\n.doc-modal .doc-create {\r\n  margin-bottom: 0;\r\n  box-shadow: none;\r\n}\r\n\r\n.doc-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1rem 1.25rem;\r\n  border-bottom: 1px solid var(--border);\r\n  background: linear-gradient(120deg, #1e1b4b 0%, #312e81 60%, #4338ca 100%);\r\n}\r\n\r\n.doc-modal-body {\r\n  padding: 1rem 1.25rem 1.5rem;\r\n}\r\n\r\n.doc-quill-modal .ql-container {\r\n  min-height: 420px;\r\n}\r\n\r\n.doc-empty {\r\n  border: 1px dashed var(--slate-300);\r\n  background: var(--bg-toolbar);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .doc-panel-drawer,\r\n  .doc-panel-inline {\r\n    width: 100%;\r\n    height: auto;\r\n    position: static;\r\n    max-height: none;\r\n  }\r\n\r\n  .doc-panel-inline .doc-panel-body {\r\n    max-height: none;\r\n  }\r\n\r\n  .doc-resize-handle {\r\n    display: none;\r\n  }\r\n\r\n  .doc-grid {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .doc-list-scroll {\r\n    max-height: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .doc-panel {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
